import './css/icons+fonts/material-design-icons+roboto-font.css'
import Vue from 'vue'
import App from './App'
import vueAnalytics from 'vue-analytics'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import router from './router'
import store from './store/index'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VAvatar,
  VStepper,
  VTextField,
  VForm,
  VCard,
  VCheckbox,
  VSelect,
  VDataTable,
  VRadioGroup,
  VMenu,
  VDatePicker,
  VSnackbar,
  VProgressCircular,
  VProgressLinear,
  VDialog,
  VDivider,
  VExpansionPanel,
  VAutocomplete,
  VTextarea,
  VBadge,
  VTooltip,
  VSwitch,
  VAlert,
  VChip,
  VPagination,
  VWindow,
  VCarousel,
  VTabs,  
} from 'vuetify'

import '../node_modules/vuetify/src/stylus/app.styl'
import Clarity from "./plugins/clarity";

const isProd = process.env.NODE_ENV === 'production'


Vue.use(Clarity, {
  enabled: isProd,
  router
});

Vue.use(vueAnalytics, {
  id: 'UA-33304555-6',
  router,
  ignoreRoutes: [],
  autoTracking: {
    pageviewOnLoad: true
  },
  debug: {
    enable: !isProd,
    sendHitTask: isProd
  }
})

Vue.use(VueChartkick, {
  adapter: Chart
})

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VAvatar,
    VStepper,
    VTextField,
    VForm,
    VCard,
    VCheckbox,
    VSelect,
    VDataTable,
    VRadioGroup,
    VMenu,
    VDatePicker,
    VSnackbar,
    VProgressCircular,
    VProgressLinear,
    VDialog,
    VDivider,
    VExpansionPanel,
    VAutocomplete,
    VTextarea,
    VBadge,
    VTooltip,
    VSwitch,
    VAlert,
    VChip,
    VPagination,
    VWindow,
    VCarousel,
    VTabs
  },
  theme: {
    primary: '#00456E',
    secondary: '#00ACC1',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    progressBarColor: '#DCDCDC',
    themeGrey: '#757575'
  }
});

Vue.config.productionTip = process.env.NODE_ENV == 'production';

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js